import React, { useState } from "react";
import { Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from "axios";

interface OrderStatusProps {
  orderPhase: string;
  onCancel: () => void;
  orderId?: string;
}

export const OrderStatus: React.FC<OrderStatusProps> = ({ orderPhase, onCancel, orderId }) => {
  const [showModal, setShowModal] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleCancelClick = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const handleConfirm = () => {
    setShowModal(false);
    onCancel();
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || !orderId) return;
    const file = files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('orderId', orderId);
    setUploading(true);
    try {
      const resp = await axios.post('/companyFormation/uploadOrderDocument', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const data = resp.data;
      if (resp.status === 200 && data.status === 'success') {
        alert('Document uploaded successfully!');
      } else {
        alert(data.error || 'Failed to upload document.');
      }
    } catch (err: any) {
      alert(err.response?.data?.error || 'Error uploading document.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
        <Card className="mb-4 shadow-sm border-0 position-relative" style={{ maxWidth: 400 }}>
          <CardBody className="d-flex flex-column align-items-center gap-3 p-4" style={{ position: 'relative' }}>
            <div className="text-center" style={{ maxWidth: 320 }}>
              <p className="mb-2" style={{ color: '#555', fontSize: 15 }}>
                Thank you for choosing BizServe for your company formation needs. Below is the current status of your order. If you have any questions or need assistance, please contact our support team.
              </p>
            </div>
            <div style={{ fontSize: 32, color: '#0d6efd' }}>
              <i className="bx bx-receipt"></i>
            </div>
            <div className="text-center">
              <h5 className="mb-1">Order Status</h5>
              <span className={`badge bg-${orderPhase === 'Completed' ? 'success' : orderPhase === 'Pending' ? 'warning' : orderPhase === 'Cancelled' ? 'danger' : 'primary' }`} style={{ fontSize: 16, padding: '6px 14px' }}>
                {orderPhase}
              </span>
            </div>
            {orderPhase === 'Cancelled' ? (
              <div className="mt-3 text-center" style={{ maxWidth: 320 }}>
                <p className="mb-0" style={{ color: '#0d6efd', fontSize: 15, fontWeight: 500, cursor: 'pointer', textDecoration: 'underline' }}
                  tabIndex={0}
                  role="button"
                  onClick={() => window.location.href = '/company-formation'}
                  onKeyPress={e => { if (e.key === 'Enter' || e.key === ' ') window.location.href = '/company-formation'; }}
                >
                  Place a new order
                </p>
              </div>
            ) : (
              <div className="mt-3 text-center" style={{ maxWidth: 320 }}>
                <p className="mb-0" style={{ color: '#888', fontSize: 13 }}>
                  If you wish to <span
                    style={{ color: '#0d6efd', textDecoration: 'underline', cursor: 'pointer', fontWeight: 500 }}
                    onClick={handleCancelClick}
                    tabIndex={0}
                    role="button"
                    onKeyPress={e => { if (e.key === 'Enter' || e.key === ' ') handleCancelClick(); }}
                  >
                    cancel
                  </span> your order, please note that cancellation is irreversible.
                </p>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      {/* Upload documents button outside the status card */}
      {orderPhase !== 'Cancelled' && (
        <div className="mt-3 d-flex justify-content-center">
          <button
            className="btn btn-outline-primary"
            style={{ fontWeight: 500 }}
            onClick={() => document.getElementById('order-doc-upload')?.click()}
            type="button"
            disabled={uploading}
          >
            {uploading ? 'Uploading...' : 'Upload documents for your order'}
          </button>
          <input
            id="order-doc-upload"
            type="file"
            style={{ display: 'none' }}
            multiple={false}
            onChange={handleFileUpload}
          />
        </div>
      )}
      <Modal isOpen={showModal} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>Cancel Order</ModalHeader>
        <ModalBody>
          Are you sure you want to cancel this order? This action cannot be undone.
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>No</Button>
          <Button color="danger" onClick={handleConfirm}>Yes, Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
